/* ==========================================================
   FODBOLDGAVER — BALANCED STOCK GRID
   Testversion til kollektioner og søgeresultater

   - Shopify filtrerer lagerførte varer før paginering
   - Højst 3 udsolgte produktkort indsættes i samme grid
   - Respekterer klub, gavetype, pris og valgt sortering
   - Aktive valg af lagerstatus respekteres altid
   ========================================================== */

(function () {
  'use strict';

  var initialized = new WeakSet();
  var STOCK_KEY = 'filter.v.availability';
  var MAX_SOLD_OUT = 3;

  function getGrid(doc) {
    return doc.querySelector(
      '.fg-collection .ProductList.ProductList--grid'
    );
  }

  function getCards(grid) {
    return grid
      ? Array.from(grid.children).filter(function (el) {
          return el.classList.contains('Grid__Cell');
        })
      : [];
  }

  function cardKey(card) {
    var link = card.querySelector('a[href*="/products/"]');

    if (!link) return '';

    try {
      return new URL(link.href, location.origin).pathname;
    } catch (_) {
      return '';
    }
  }

  function isSoldOutCard(card) {
    // Kun kort, som temaet faktisk markerer "Udsolgt".
    return /\budsolgt\b/i.test(card.textContent || '');
  }

  function requestUrl(section, availability, page) {
    var url = new URL(location.href);

    url.searchParams.set(
      STOCK_KEY,
      String(availability)
    );

    url.searchParams.set('page', String(page));

    url.searchParams.set(
      'section_id',
      section.dataset.sectionId
    );

    url.searchParams.delete('sections');

    // Udsolgte varer vælges efter tidligere salg på
    // kollektioner og relevans på søgesider.
    if (availability === 0) {
      if (/\/collections\//.test(location.pathname)) {
        url.searchParams.set('sort_by', 'best-selling');
      } else {
        url.searchParams.set('sort_by', 'relevance');
      }
    }

    return url.toString();
  }

  async function getSection(url) {
    var response = await fetch(url, {
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error(
        'Section response ' + response.status
      );
    }

    var html = await response.text();

    return new DOMParser().parseFromString(
      html,
      'text/html'
    );
  }

  function replacePagination(section, source) {
    var current = section.querySelector('.Pagination');

    var sourcePagination = source.querySelector(
      '.fg-collection .Pagination'
    );

    if (!sourcePagination) {
      if (current) current.remove();
      return;
    }

    var next = document.importNode(
      sourcePagination,
      true
    );

    // Den offentlige URL skal fortsat være uden
    // vores interne lagerfilter.
    next.querySelectorAll('a[href]').forEach(function (link) {
      var url = new URL(link.href, location.origin);

      url.searchParams.delete(STOCK_KEY);
      url.searchParams.delete('section_id');

      link.href = url.toString();
    });

    if (current) {
      current.replaceWith(next);
    } else {
      var wrapper = section.querySelector(
        '.ProductListWrapper'
      );

      if (wrapper) {
        wrapper.insertAdjacentElement(
          'afterend',
          next
        );
      }
    }
  }

  function mixCards(inStock, soldOut) {
    var count = inStock.length;
    var result = [];
    var nextIndex = 0;

    // Fordel udsolgte jævnt mellem lagerførte.
    var positions = soldOut.map(function (_, index) {
      return Math.max(
        1,
        Math.round(
          (index + 1) * count /
          (soldOut.length + 1)
        )
      );
    });

    inStock.forEach(function (card, index) {
      result.push(
        document.importNode(card, true)
      );

      while (
        nextIndex < soldOut.length &&
        positions[nextIndex] === index + 1
      ) {
        var extra = document.importNode(
          soldOut[nextIndex],
          true
        );

        extra.dataset.fgSupplementalSoldOut = 'true';

        result.push(extra);
        nextIndex++;
      }
    });

    return result;
  }

  async function balance(section) {
    if (!document.contains(section)) return;
    if (!section.dataset.sectionId) return;

    var params = new URLSearchParams(
      location.search
    );

    // Hvis kunden selv vælger lagerstatus,
    // respekteres Shopifys native filter.
    if (params.has(STOCK_KEY)) return;

    var grid = getGrid(section);

    if (!grid) return;

    var page = Math.max(
      1,
      parseInt(params.get('page') || '1', 10) || 1
    );

    var pageSize = Math.max(
      1,
      Number(section.dataset.fgPageSize) || 16
    );

    // Brug forskellige udsolgte varer på nye sider,
    // så vi ikke gentager de samme kort overalt.
    var soldOutIndex = (
      page - 1
    ) * MAX_SOLD_OUT;

    var soldOutPage = Math.floor(
      soldOutIndex / pageSize
    ) + 1;

    var soldOutOffset = soldOutIndex % pageSize;

    try {
      var sources = await Promise.allSettled([
        getSection(
          requestUrl(section, 1, page)
        ),
        getSection(
          requestUrl(section, 0, soldOutPage)
        )
      ]);

      if (
        !document.contains(section) ||
        sources[0].status !== 'fulfilled'
      ) {
        return;
      }

      var stockDocument = sources[0].value;
      var stockGrid = getGrid(stockDocument);
      var stockCards = getCards(stockGrid);

      var oldGrid = getGrid(section);

      if (!oldGrid) return;

      var soldCards = [];

      if (sources[1].status === 'fulfilled') {
        var soldGrid = getGrid(
          sources[1].value
        );

        var known = new Set(
          stockCards.map(cardKey).filter(Boolean)
        );

        soldCards = getCards(soldGrid)
          .slice(soldOutOffset)
          .filter(function (card) {
            var key = cardKey(card);

            if (
              !key ||
              known.has(key) ||
              !isSoldOutCard(card)
            ) {
              return false;
            }

            known.add(key);
            return true;
          });
      }

      if (!stockGrid && !soldCards.length) {
        return;
      }

      if (!stockCards.length) {
        // Hvis alt er udsolgt, vis højst 3.
        var fallback = soldCards
          .slice(0, MAX_SOLD_OUT)
          .map(function (card) {
            return document.importNode(
              card,
              true
            );
          });

        if (!fallback.length) return;

        oldGrid.replaceChildren.apply(
          oldGrid,
          fallback
        );

        var currentPager = section.querySelector(
          '.Pagination'
        );

        if (currentPager) {
          currentPager.remove();
        }

      } else {
        // 16 på lager -> maks. 3 udsolgte.
        // 10 på lager -> maks. 2 udsolgte.
        var limit = Math.min(
          MAX_SOLD_OUT,
          Math.floor(stockCards.length / 5)
        );

        var selected = soldCards.slice(
          0,
          limit
        );

        var items = mixCards(
          stockCards,
          selected
        );

        oldGrid.replaceChildren.apply(
          oldGrid,
          items
        );

        replacePagination(
          section,
          stockDocument
        );
      }

      // Til eventuelle dynamiske produktkort-moduler.
      section.dispatchEvent(
        new CustomEvent('fg:product-grid:updated', {
          bubbles: true,
          detail: {
            grid: oldGrid
          }
        })
      );

    } catch (error) {
      // Ved fejl bevares den almindelige produktliste.
      console.warn(
        '[FG stock balance] Default grid preserved:',
        error
      );
    }
  }

  function init(root) {
    (root || document).querySelectorAll(
      '.fg-collection[data-fg-balanced-stock="true"]'
    ).forEach(function (section) {
      if (initialized.has(section)) return;

      initialized.add(section);
      balance(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        init();
      },
      { once: true }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      init(event.target);
    }
  );
})();